import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ManImg from '../components/ManImg'
import { en, th } from '../Variable';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export default function Success() {

    let params = useParams();
    const [contactBackParam, setContactBackParam] = useState<string | undefined>('noContact');
    const [lang, setLang] = useState<string | undefined | null>('en');

    useEffect(() => {
        const _contactBack = params.contactBack;
        setContactBackParam(_contactBack?.toString());
        const _lang = params.lang;
        if (_lang !== undefined) {
            setLang(_lang?.toString());
        }
    }, [params]);

    return (
        <Container>
            <Row>
                <Col className='dropdown-col' lg={12}>
                    <Dropdown onSelect={(eventKey) => setLang(eventKey)}>
                        <Dropdown.Toggle>
                            <FontAwesomeIcon icon={faGlobe as IconProp} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item eventKey={'en'} active={lang === 'en'}>EN</Dropdown.Item>
                            <Dropdown.Item eventKey={'th'} active={lang === 'th'}>TH</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
            </Row>
            <div className="success">
                <div className="success__title">
                    <h1>{lang === 'en' ? en.thankLabel : th.thankLabel}</h1>
                    <div className="success__subtitle">{contactBackParam === 'contactBack' ? lang === 'en' ? en.thankContactSubLabel : th.thankContactSubLabel : lang === 'en' ? en.thankSubLabel : th.thankSubLabel}</div>
                </div>
                <ManImg />
            </div>

            <footer>
                <div className="footer-info">
                    <div className="footer-info__info">{lang === 'en' ? en.inquiriesLabel : th.inquiriesLabel}</div>
                    <div className="footer-info__wrapper">
                        <a href={`tel:${process.env.REACT_APP_TEL}`} className="footer-info__number">
                            <div className={`number-${lang}`}>02-712-7272</div>
                        </a>
                        <a href={`mailto:${process.env.REACT_APP_EMAIL}`} className="footer-info__email">
                            <div className={`email-${lang}`}>info@sprinkle-th.com</div>
                        </a>
                        <a href={process.env.REACT_APP_LINE} className="footer-info__line">
                            <div className={`line-${lang}`}>@sprinklewater</div>
                        </a>
                    </div>
                </div>
                <div className="footer-copywriter">&#169; {lang === 'en' ? en.copyrightsLabel : th.copyrightsLabel}</div>
            </footer>
        </Container>
    )
}